module.exports = __webpack_public_path__ + "static/lageplan_mini-fb5626a741add11a54f551974422e29f.png";